import React from "react";

// Components
import MaterialTable from "material-table";
import Grid from "@material-ui/core/Grid";
import SectionTitle from "./SectionTitle";

// Icons
import tableIcons from "../../Table/TableIcons";

const ProductsTableComponent = ({productsArray, isLoading, headerAction}) => {
  // Need to spread array so it doesn't fail
  const formatData = productsArray => {
    return productsArray.map(o => ({
      ...o,
    }));
  };

  // Local State
  const formattedData = formatData(productsArray);

  return (
    <Grid container item xs={12}>
      <Grid item xs={12}>
        <MaterialTable
          title={<SectionTitle title="Products" action={headerAction} />}
          isLoading={isLoading}
          icons={tableIcons}
          columns={[
            {
              title: "Name",
              field: "name",
            },
            {
              title: "Price",
              field: "price",
              type: "currency",
              headerStyle: {
                textAlign: "right",
              },
            },
            {
              title: "Tax",
              field: "tax",
              type: "numeric",
              render: rowData => <>{rowData.tax}%</>,
            },
            {
              title: "Quantity",
              field: "quantity",
              type: "numeric",
            },
            {
              title: "Frequency",
              field: "type",
            },
            {
              title: "Applies To",
              field: "age_restriction",
            },
            {
              title: "Product Type",
              field: "product_type",
              render: rowData => (
                <>
                  {rowData.product_type.charAt(0).toUpperCase() +
                    rowData.product_type.slice(1)}
                </>
              ),
            },
          ]}
          data={formattedData}
          options={{
            search: false,
            paging: false,
          }}
          localization={{
            body: {emptyDataSourceMessage: "No products on this order."},
          }}
        />
      </Grid>
    </Grid>
  );
};

export default ProductsTableComponent;
